import apiService from './apiService';

const spaSettingsService = {
    getDefault: async () => {
        return await apiService.get(`/api/v1/SpaSettings`);
    },
};

export default spaSettingsService;
